import { apiAxiosInstance, post } from "./handler";

export const verifyLaserId = async (payload) => {
  try {
    const result = await post(
      "/regisEarthQuake/verifyLaserId",
      payload,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const verifyCif = async (payload) => {
  try {
    const result = await post(
      "/regisEarthQuake/verifyCif",
      payload,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const verifyCifAndAcct = async (payload) => {
  try {
    const result = await post(
      "/regisEarthQuake/verifyCifAndAcct",
      payload,
      undefined,
      apiAxiosInstance,
      undefined
    );
    return result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
